const HomeStyle = {
  hiwCardContent: {
    marginLeft: '2vw',
  },
  hiwCardContainer: {
    width: '50vw',
    overflow: 'hidden',
    background: '#FFFFFF',
    marginBottom: 100,
  },
  hiwCardData: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '1.5em',
    lineHeight: '25px',
    color: '#575765',
    marginTop: '1.3em',
  },
  hiwCardDiscription: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '1.5em',
    lineHeight: '20px',
    color: '#575765',
    width: '45vw',
  },
  hiwCardHeader: {
    fontFamily: 'Montserrat',
    fontSize: 38,
    fontStyle: 'normal',
    fontWeight: '600',
    paddingBottom: 25,
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '3vh',
    overflowX: 'hidden',
  },
  flexContainer__text: {
    width: '73vw',
    alignSelf: 'center',
    paddingBottom: 25,
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '1.5em',
    lineHeight: '20px',
    color: '#575765',
  },
  flexBoxForCard: {
    marginTop: 25,
    display: 'flex',
    width: '100vw',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  imageStyle: {
    width: '23vw',
    height: '30vh',
  },
  scrolling: {
    overflowY: 'scroll',
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    marginTop: '9em',
  },
  cardContainer: {
    overflow: 'hidden',
    background: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0px 2px 4px -2px',
    borderTop: '1px solid grey',
    marginBottom: 20,
  },
  cardData: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '1.5em',
    lineHeight: '25px',
    color: '#34343E',
    marginTop: '1.3em',
  },
  cardDiscription: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '2em',
    lineHeight: '20px',
    color: '#34343E',
    marginTop: '1.3em',
  },
  cardHeader: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '5em',
  },
  cardContent: {
    marginTop: '4em',
    marginLeft: '3em',
    marginRight: '3em',
  },
  mainHeading: {
    fontFamily: 'Montserrat',
    fontSize: 38,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '49px',
    letterSpacing: '0px',
    textAlign: 'center',
    height: '49px',
    width: '407px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '2vh',
  },
  heading: {
    height: '40px',
    width: '500px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '4vh',
    borderRadius: 'null',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px',
    textAlign: 'center',
  },
  boxToHoldTopBar: {
    width: '100%',
    height: '7vh',
    color: 'white',
    backgroundColor: '#010101',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  boxToHoldLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'inherit',
  },
  logoIconProperties: {
    height: '7vh',
  },
  boxtoHoldHomeTCWorks: {
    height: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  boxToHoldLoginSignupButtons: {
    height: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },

  boxToHoldLoginButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #010101',
    height: 'inherit',
  },
  loginButtonProperties: {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    height: 'inherit',
    padding: '1vh 1vw',
    cursor: 'pointer',
  },

  boxToHoldSignupButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #010101',
    cursor: 'pointer',
  },
  signupButtonProperties: {
    color: 'black',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '35px',
    fontSize: '14px',
    padding: '1.5vh 3vw',
  },
  htcwButtonProperties: {
    fontSize: '14px',
    color: 'white',

    padding: '0vh 2vw',
  },
  flexBoxTSGB: {
    display: 'flex',
    paddingLeft: '5vw',
    paddingTop: '20vh',
  },
  titleHoldingBox: {
    paddingBottom: 28,
  },
  titleBox: {
    fontSize: 38,
    width: '700px',
  },
  subtitleholdingBox: {},
  subtitleBox: {
    fontSize: '18px',
    width: '500px',
  },
  getStartedButtonHoldingBox: {
    paddingTop: '40px',
  },
  getStartedBox: {
    width: '500px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  getStartedButtonProperties: {
    backgroundColor: 'black',
    color: '#FAFAFA',
    fontSize: '14px',
    width: '192px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50px',
  },
};

export default HomeStyle;
